import { ReactComponent as YoutubeMusicColorLight } from 'fym-shared/src/music-services/assets/images/youtube-music-color-light.svg';
import { ReactComponent as YoutubeMusicColorDark } from 'fym-shared/src/music-services/assets/images/youtube-music-color-dark.svg';
import { ReactComponent as YoutubeMusicColorLightPadding } from 'fym-shared/src/music-services/assets/images/youtube-music-color-light-padding.svg';
import { ReactComponent as YoutubeMusicColorDarkPadding } from 'fym-shared/src/music-services/assets/images/youtube-music-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const youtubeMusicImages: MusicServiceImages = {
  logoColor: {
    light: YoutubeMusicColorLight,
    dark: YoutubeMusicColorDark,
  },
  logoColorPadding: {
    light: YoutubeMusicColorLightPadding,
    dark: YoutubeMusicColorDarkPadding,
  },
};
